import ReactGA from "react-ga";
import tryParseInt from "../../utils/tryParseInt";

export const initGA = trackingID => {
  ReactGA.initialize(trackingID);
};

export const PageView = () => {
  ReactGA.pageview(window.location.pathname + window.location.search);
};

export const Event = (category, action, label, value) => {
  const args = { category: category, action: action, label: label };

  if (tryParseInt(value)) {
    const valueAsNumber = Math.round(Number(value));
    args.value = valueAsNumber;
  }

  ReactGA.event(args);
};
